export default "__VITE_ASSET__Aa1lNpHd__"